export function parseLanguageToShortLanguage(language: string): string {
    switch(language) {
        case 'en-GB':
        case 'en-US':
        case 'en':
            return 'en';
        case 'fr-FR':
        case 'fr-BE':
        case 'fr':
            return 'fr';
        default:
            return 'nl';
    }
}

export function parseLanguageToFullLanguage(language: string): string {
    switch(language) {
        case 'en-GB':
        case 'en-US':
        case 'en':
            return 'en-GB';
        case 'fr-FR':
        case 'fr-BE':
        case 'fr':
            return 'fr-FR';
        default:
            return 'nl-NL';
    }
}
